import React from 'react';
import { useSelector } from 'react-redux';
import { BreakpointContext } from '../BreakpointContext/BreakpointContext';
import { breakpointHook } from '../../utils/breakpointHook';
export const BreakpointProvider = (props) => {
    const { children, autoAdjust = true } = props;
    const md = useSelector((state) => state.md);
    // patching for old naming
    if (md && md.isEmbbedInBuyerApp) {
        md.isEmbeddedInBuyerApp = md.isEmbbedInBuyerApp;
    }
    const value = breakpointHook(md, autoAdjust);
    return React.createElement(BreakpointContext.Provider, { value: value }, children);
};
